import React from 'react';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const IconCard = ({ text, Icon }) => {
    return (
        <div className='box-shadow-shades-800-opacity-25-20 border-radius-12px p-2 background-general-00 w-124px h-149px d-flex flex-column align-items-center justify-content-center'>
            <div className='background-primary-50 border-full-primary-500 box-shadow-primary-900-opacity-10-blur-20 border-radius-12px d-flex align-items-center justify-content-center p-3 w-100px h-100px'>
                {Icon && <Icon />}
            </div>

            <p className='font-color-shades-500 ibl-font-w-600 ibl-ientry-p mt-2 mb-0 text-center text-uppercase'>{text}</p>
        </div>
    );
};

export default IconCard;
